import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactDatatable from "@ashvin27/react-datatable";
import { Modal, Button } from "react-bootstrap";
import { getDateISOFormat, getPatientsubstring } from "../constants/globalLevelFunctions";
//import FooterSection from "../components/UI/FooterSection";
import axios from "axios";
import { CONFIG } from "../config/data";
import Spinner from "../components/UI/Spinner";
import DatePicker from "react-date-picker";
import InputField from "../components/UI/InputField";
import Validation from "../actions/Validation";
import { Popup } from "../components/UI/Popup";
import CheckboxOrRadioGroup from "../components/UI/CheckboxOrRadioGroup";
import Label from "../components/UI/Label";
import * as moment from "moment";
import {
    consultPsychiatristDoctor, getAllBusinessList, getCheckinDetails, getQEntryById, createNotification,consultPsychiatristAssessmentDoctor,
    UpdateQueueForCheckOut, sendemail, sendsms, updateclientappointmentstatus, searchBusiness, getDocByBusiness, getDocByBusinesswithspeciality
} from "../config/url.json";
import {
    stringToLabelValue,
    getKeyFromValue,
    getMaxIdOfRecords,
    calculate_age,
} from "../constants/globalLevelFunctions";
import Select from "react-select";
import { withRouter } from "react-router-dom";
import SpanField from "../components/UI/SpanField";
import TextArea from "../components/UI/TextArea";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import Dnaspinner from '../components/UI/Dnaspinner';
function mapStateToProps(state) {
    return {
        appdata: state.AppData,
        userdata: state.AuthReducer.user,
        access_token: state.AuthReducer.access_token,
    };
}

function mapDispatchToProps(dispatch) {
    return {

    };
}
const purpose_of_the_session = ["Routine Follow-up", "Initial Assessment", "Criss Intervention", "Therapy/Counselling", "Others"];
const patient_current_status = ["Stable", "Mild Symptoms", "Moderate Symptoms", "Severe Symptoms", "Critical Condition"];
const progress_towards_goal = ["No Progress", "Slight Improvement", "Moderate Improvement", "Significant Improvement", "Goal Achieved"];
const Challenges = ["Non Compliance with treatment", "Financial constraints", "Lack of family support","Psychological barriers","Side effects of medication"];

const followup = ['followup'];
let eq_record = {
    id: "",
    education: "",
    specialization: "",
    university: "",
    completion_month: "",
    completion_year: "",
};

let cert_record = {
    education_level: "",
    specialization: "",
    valid_URL: "",
    certification_completion_month: "",
    certification_completion_year: "",
    valid_upto_month: "",
    valid_upto_year: "",
    id: "",
};

let experience_record = {
    hospital: "",
    ex_address: "",
    ex_city: "",
    ex_state: "",
    ex_country: "",
    ex_zipcode: "",
    experience_from: "",
    experience_to: "",
    id: "",
};
let socio_demographic_record = {
    id: "",
    education_level: "",
    occupation: "",
    living_situation: "",
};
class AssessmentPsychiatrist extends Component {
    constructor(props) {
        super(props);
        this.config = {
            page_size: 10,
            length_menu: [10, 20, 50],
            button: {
                excel: false,
                print: false,
            },
            show_first: false,
            show_info: false,
            show_last: false,
            show_filter: false,
            show_length_menu: false,
        };

        this.state = {
            business_list: [],
            searchData: { business_name: "", speciality: "" },
            speciality_error: "",
            searchresults: {
                data: [],
            },
            successMessage: "",
            errorMessage: "",
            selected_doc: { value: "", label: "" },
            doctor_list: [],
            openModal: false,
            selected_doctor_appointment_detail_list: [],
            selected_doc_schedule_type: "",
            checkindetails: {},
            socio_demographic_details: [],
            queuein_data: {

            },
            Assessment: {
                id: "",
                client_id: "",
                business_id: "",
                business_user_id: "",
                purpose_of_the_session: [],
                purpose_of_the_session_value:"",
                overview_of_the_session_value:"",
                patient_current_status:[],
                patient_current_status_value:"",
                progress_towards_goal:[],
                progress_towards_goal_value:"",
                challenges:[],
                challenges_value:"",
                interventions_value:"",
                actionplanrecommendation_value:"",
                conclusion:"",

            },
            caseHistory: {
                socio_demographic_formData: {
                    education_level: "",
                    occupation: "",
                    living_situation: "",

                },
                presenting_complaints_formData: {
                    main_issue: "",
                    duration: "",
                    severity: "",
                    triggers: [],
                },
                presenting_factors_formData: {
                    immediate_symptoms: "",
                    stressors: [],
                },
                past_treatment_history: {
                    previous_diagnosis: "",
                    treatment: "",
                    response_to_treatment: "",

                },
                family_history: {
                    family_history_of_mental_health_issues: "",
                    type_of_conditions: "",
                    genogram: "",
                },
                developmental_history: {
                    birth_history: "",
                    early_milestone: {
                        sitting_up: "",
                        speech_development: "",
                    },
                    social_development: {
                        early_friendships: "",
                        group_activities_participation: "",
                    },
                    academic_performance: {
                        early_schooling_experience: "",
                        grades_and_subjects: "",
                    },
                    family_dynamics: {
                        relationship_with_parents_siblings: "",
                        significant_family_events: "",

                    },
                    behavioral_issues: {
                        reported_problems_in_childhood: "",
                        invervention_or_assessments: "",
                    },

                },
                premorbid_history: {

                    personality_traits: "",
                    social_relationship: "",
                    functioning_in_daily_life: "",
                },
                preciptating_history: {
                    recent_life_events: [],
                    changes_in_routine: "",
                },
                perpetuating_factors: {
                    ongoing_stressors: [],
                    behavioural_pattern_maintaining_symptoms: "",
                    lack_of_support_system: "",
                },
                prognostic_factors: {
                    severity_and_duration_of_symptoms: "",
                    response_to_previous_treatments: "",
                    support_systems_available: "",
                    comorbid_conditions: "",

                },
                mental_status_examination: {
                    appearence: "",
                    behavior: "",
                    speech: "",
                    mood: "",
                    thought_process: "",
                    thought_content: "",
                    perception: "",
                    cognition_orientation: "",
                    insight: "",

                },
                case_formulation: "",
            },


            socio_demographic_error: {
                education_level: "",
                occupation: "",
                living_situation: "",
            },
            presenting_complaints_error: {
                main_issue: "",
                duration: "",
                severity: "",
                triggers: [],
            },
            presenting_factors_error: {
                immediate_symptoms: "",
                stressors: [],
            },
            past_treatment_history_error: {
                previous_diagnosis: "",
                treatment: "",
                response_to_treatment: "",

            },
        }

        this.socio_demographic_columns = [
            {
                key: "id",
                text: "S.No",
                className: "s_no",
                align: "left",
                sortable: true,
            },
            {
                key: "education_level",
                text: "Education Level",
                className: "education_level",
                align: "left",
                sortable: true,
            },
            {
                key: "occupation",
                text: "Occupation",
                className: "occupation",
                sortable: true,
                align: "left",
            },
            {
                key: "living_situation",
                text: "Living Situation",
                className: "living_situation",
                sortable: true,
                align: "left",

            },
            {
                key: "action",
                text: "Action",
                show: false,
                width: 100,
                align: "left",
                className: "hideAction",
                TrOnlyClassName: "hideAction",
                sortable: true,
                cell: (record) => {
                    return (
                        <Fragment>
                            <button
                                type="button"
                                className="btn btn-blue btn-sm btn-space"
                                onClick={() => {
                                    this.setState({ medEdit: true, medAction: "edit" });
                                    this.editMedicalRecord(record);
                                }}
                            >
                                <i className="fa fa-edit"></i>
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger btn-sm btn-space"
                                onClick={() => this.onDeleteClick(record, "socioDemographic")}
                            >
                                <i className="fa fa-trash"></i>
                            </button>
                        </Fragment>
                    );
                },
            },
        ];
    }
    onDeleteClick(record, tableName) {
        this.setState({ addPopup: true, record: record, tableName: tableName });
    }

    deleteRecord(record, tableName) {
        if ("education" === tableName) {
            let records = this.state.businessUserData.educational_qualification;
            const deleteIndex = records.map((item) => item.id).indexOf(record.id);
            records.splice(deleteIndex, 1);
            toast.success("Education deleted.Please save the changes. ", {
                className: "toast-success"
            });
        } else if ("certificate" === tableName) {
            let records = this.state.businessUserData.certification;
            const deleteIndex = records.map((item) => item.id).indexOf(record.id);
            records.splice(deleteIndex, 1);
            toast.success("Certificate deleted.Please save the changes. ", {
                className: "toast-success"
            });
        } else if ("experience" === tableName) {
            let records = this.state.businessUserData.experience;
            const deleteIndex = records.map((item) => item.id).indexOf(record.id);
            records.splice(deleteIndex, 1);
            toast.success("Experience deleted.Please save the changes. ", {
                className: "toast-success"
            });
        } else if ("socioDemographic" === tableName) {
            let records = this.state.socio_demographic_details;
            const deleteIndex = records.map((item) => item.id).indexOf(record.id);
            records.splice(deleteIndex, 1);
            toast.success("Socio Demographic deleted.Please save the changes. ", {
                className: "toast-success"
            });
        }
        this.setState({ addPopup: false, record: "" });
    }
    componentDidMount() {


        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;
        console.log(this.props.id)
        const checkinData = { id: this.props.id };

        axios
            .post(getCheckinDetails, checkinData, CONFIG)
            .then((res) => {
                let data = res.data.data || res.data.date;
                if (res.data.status !== "1" || !data) {
                    return;
                }


                console.log(res.data.status)
                this.setState({
                    checkindetails: res.data.data,
                    client_id: this.state.checkindetails.client_id,
                    business_id: this.state.checkindetails.business_id,
                    business_user_id: this.state.checkindetails.business_user_id,

                });
                console.log(this.state.checkindetails);
                console.log(this.state.checkindetails.client_id);



            }).catch((e) => { });

        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;
        axios
            .get(getAllBusinessList, null, CONFIG)
            .then((list) => {
                console.log(list)
                let business = [];
                let userlist = list.data.data;
                userlist.forEach((element, index) => {
                    business.push({ label: element.business_name, value: element.user_id })
                });

                this.setState({ business_list: business });
            })
            .catch((e) => { console.log(e) });
    }
    clearMessage = () => {
        setTimeout(
            () =>
                this.setState({
                    successMessage: "",
                    errorMessage: "",

                }),
            5000
        );
    };

    handleInput = (e) => {
        let data = this.state.followupData;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        console.log(max);

        if (
            name === "follow_up_details" || name === "consultation_fee") {



            this.validateMaxLength(name, value, max);
        }

        else {
            data[name] = value;
        }
        this.setState({ followupData: data });

    }

    closePopup = (e) => {
        this.setState({
            openModal: false, errors: {}, error: "", successMessage: "", errorMessage: "",
            listofClientForQueue: []
        });
    };

    handleselectDocChange = (selectedOptions, e) => {
        let data = this.state.selected_doc;
        data = selectedOptions;

        this.setState({ selected_doc: data });

        console.log(this.state.doctor_appointment_detail_list);

        let appointmentDetails = this.state.doctor_appointment_detail_list;

        let selected_appointment = this.state
            .selected_doctor_appointment_detail_list;

        let selected_doc_schedule_type = this.state.selected_doc_schedule_type;

        appointmentDetails.forEach((element, index) => {
            console.log(element.business_user_id);
            console.log(element.doctor_Appointments);
            if (element.business_user_id == selectedOptions.value) {
                console.log("true");
                selected_appointment = element.doctor_Appointments;
                selected_doc_schedule_type = element.schedule_type;
            } else {
                console.log("false");
            }
        });
        this.setState({
            selected_doctor_appointment_detail_list: selected_appointment,
            selected_doc_schedule_type: selected_doc_schedule_type
        });
    };

    handleselectChange = (selectedOptions, e) => {
        let data = this.state.searchData;
        let errors = this.state.errors;
        // console.log(e.name);
        data[e.name] = selectedOptions;

        // if (e.name === "business_name" && null != selectedOptions) {
        //   console.log(selectedOptions);
        //   data.latitude = selectedOptions.latitude;
        //   data.longitude = selectedOptions.longitude;
        // } else {
        //   data.latitude = this.state.latitude;
        //   data.longitude = this.state.longitude;
        // }
        this.setState({ searchData: data, errors, speciality_error: "" });


    };
    handleQueueInput = (e) => {
        let data = this.state.queuein_data;
        let name = e.target.name;
        let value = e.target.value;
        data[name] = value;
        this.setState({ queuein_data: data });
    }
    createNotification = () => {
        let { queuein_data, selected_doc, checkindetails } = this.state;
        console.log(queuein_data);
        console.log(checkindetails);
        let message = "<p>Hi " + checkindetails.first_name + " " + checkindetails.last_name + ",</p>" + "Thank you for visiting " + selected_doc.label + " referred you for an appointment at " + queuein_data.business_name + " hospital for checkups.<p> Please arrive 10 minutes prior to your appointment time.Thank you.</p><p>Sincerely,</p><p>KlinicQ Team.</p>";
        //return false;

        let notification_message = "Hi " + checkindetails.first_name + " " + checkindetails.last_name + "," + " Thank you for visiting " + selected_doc.label + " referred you for an appointment at " + queuein_data.business_name + " hospital for checkups. Please arrive 10 minutes prior to your appointment time.Thank you.Sincerely,KlinicQ Team.";

        let notificationdata = {
            message_from: selected_doc.value,
            message_to: checkindetails.client_id,
            message: notification_message,
            link: "",

        }


        let reqdata = {
            "to": checkindetails.email,
            "subject": "Referral Doctor",
            "mailHeader": "Referral Doctor",
            "message": message
        }
        let notificationdata1 = {
            "message_code": "REFERRAL_DOCTOR",
            "language_code": "en",
            "data": {
                "doctor_name": selected_doc.label,
                "business_name": queuein_data.business_name

            },
            "receiver": {
                "phoneNumber": checkindetails.phone_code.concat(checkindetails.phone_number)
            }
        };


        this.setState({ loading: true }, () => {
            axios.post(createNotification, notificationdata).then((res) => {



                axios
                    .post(sendemail, reqdata)
                    .then((res) => {
                        let resdata = res.data;
                        console.log(res);
                        axios
                            .post(sendsms, notificationdata1)
                            .then((response) => { console.log(response) }).catch((err) => {
                                console.log(err);
                            })
                        /*   toast.success("Referral doctor successfully.", {
                            className: "toast-success",
                            }); */
                        this.setState({ successMessage: "The Referral mail has been sent successfully.", loading: false });
                        this.clearMessage();
                    })
                    .catch((e) => { console.log(e) });



                this.closePopup();
                // console.log(this.state.queuein_data); return false;
                // this.props.history.push("/scheduleconfirmation/" + qid);

                // window.location.replace("/scheduleconfirmation/" + qId);
            }).catch((e) => {

            });
        });






    }
    clear = () => {
        let search = { business_name: "", speciality: "" };
        let searchresults = {
            data: [],
        };
        this.setState({ searchresults: searchresults, searchData: search, speciality_error: "", errorMessage: "" });

    }
    render() {
        let PopupClose = () => this.setState({ addPopup: false });
        let PopupConfirm = () =>
            this.deleteRecord(this.state.record, this.state.tableName);
        let specialities_array = this.props.appdata
            ? this.props.appdata[0].specialities
            : [];
        let specialities = [];
        specialities_array.forEach((element, index) => {
            specialities.push({ value: element.id, label: element.name });
        });
        specialities_array = specialities;
        const {
            business_list, searchData, searchresults, selected_doc, doctor_list, caseHistory, loading, successMessage,
            errorMessage, socio_demographic_formData, presenting_complaints_formData, Assessment,
            socio_demographic_error, presenting_complaints_error, presenting_factors_formData, presenting_factors_error
        } = this.state;
        return (
            <>
                <div className="col-sm-12 pr0">


                    {loading && <Dnaspinner />}

                    <ToastContainer position="bottom-center" hideProgressBar={true} autoClose={2000} closeOnClick={false} pauseOnHover />

                    <div className="card">
                        <div className="user-notification">
                            <SpanField
                                classname="text-success mt-2"
                                title={successMessage}
                            />
                            <SpanField
                                classname="text-danger mt-2"
                                title={errorMessage}
                            />
                            <Popup
                                show={this.state.addPopup}
                                onHide={PopupClose}
                                onConfirm={PopupConfirm}
                                title={"Confirmation"}
                                message={
                                    "Are you sure you want to delete this record ?"
                                }
                            />
                        </div>
                        <div className="card-body">
                            <div className="tab-content  pd-15" id="v-pills-tabContent">
                                <div className="tab-pane fade show active" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">

                                    <div className="col-sm-12">
                                        <h5 className=" mt-0 mb-15">
                                            <b>1.Purpose of the Session</b>
                                            {/* <button
                                                style={{
                                                    display: this.state.isDisable
                                                        ? "none"
                                                        : "",
                                                }}
                                                type="button"
                                                className="btn btn-blue btn-sm btn-space"
                                                onClick={() => {
                                                    this.setState({
                                                        medEdit: true,
                                                    });
                                                }}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </button> */}
                                        </h5>

                                        <div
                                            className="row nomargin"
                                            style={{
                                                display: this.state.medEdit
                                                    ? "flex"
                                                    : "flex",
                                            }}
                                        >
                                            <Fragment>

                                                <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group frllft">
                                                            {/* <Label title="Education Level" className="label" isMandatory={true} /> */}
                                                        </div>

                                                        <div className="form-group ">
                                                            <CheckboxOrRadioGroup
                                                                setName={"purpose_of_the_session"}
                                                                type={"radio"}
                                                                controlFunc={this.handlePurposeofthesession}
                                                                options={purpose_of_the_session}
                                                                selectedOptions={[Assessment.purpose_of_the_session]}
                                                            />

                                                        </div>
                                                        <SpanField
                                                            classname="text-danger"
                                                            title={
                                                                socio_demographic_error.education_level
                                                            }
                                                        />
                                                    </div>

                                                </div>
                                                {/* <div className="col-md-12">
                                                  
                                                    <div className="frllftfull">
                                                        <div className="form-group  frllft">
                                                            <Label title="Occupation" className="label" isMandatory={true} />
                                                        </div>
                                                        <div className=" frlrit">
                                                            <div className="form-group ">
                                                                <CheckboxOrRadioGroup
                                                                    setName={"occupation"}
                                                                    type={"radio"}
                                                                    controlFunc={this.handleOccupation}
                                                                    options={occupation}
                                                                    selectedOptions={[caseHistory.socio_demographic_formData?.occupation]}
                                                                />

                                                            </div>
                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.occupation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group">
                                                            <div className="form-group  frllft">
                                                                {/* <Label title="Living Situation" className="label" isMandatory={true} /> */}
                                                            </div>
                                                            <TextArea
                                                                className="textareacontainer"
                                                                rows={4}
                                                                resize={true}
                                                                content={this.state.Assessment.purpose_of_the_session_value || ""}
                                                                name="purpose_of_the_session_value"
                                                                controlFunc={this.handlePurposeofthesessionInputChange}
                                                                placeholder="Describe here"
                                                                maxLength={200}
                                                            />


                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.living_situation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-sm-3">
                                                    <label></label>
                                                    <div className="row">

                                                        {/* <button
                                                            type="button"
                                                            onClick={this.cancelAddEdit.bind(
                                                                this,
                                                                "medicalLicence"
                                                            )}
                                                            className="plusbtn-lft plusbtn-position"
                                                        >
                                                            <i
                                                                className="fa fa fa-ban"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button> */}


                                                    </div>
                                                </div>
                                            </Fragment>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <h5 className=" mt-0 mb-15">
                                            <b>2.Overview of the Session</b>
                                            {/* <button
                                                style={{
                                                    display: this.state.isDisable
                                                        ? "none"
                                                        : "",
                                                }}
                                                type="button"
                                                className="btn btn-blue btn-sm btn-space"
                                                onClick={() => {
                                                    this.setState({
                                                        medEdit: true,
                                                    });
                                                }}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </button> */}
                                        </h5>

                                        <div
                                            className="row nomargin"
                                            style={{
                                                display: this.state.medEdit
                                                    ? "flex"
                                                    : "flex",
                                            }}
                                        >
                                            <Fragment>

                                                {/* <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group frllft">
                                                            <Label title="Education Level" className="label" isMandatory={true} />
                                                        </div>

                                                        <div className="form-group ">
                                                            <CheckboxOrRadioGroup
                                                                setName={"purpose_of_the_session"}
                                                                type={"radio"}
                                                                controlFunc={this.handlePurposeofthesession}
                                                                options={purpose_of_the_session}
                                                                selectedOptions={[Assessment.purpose_of_the_session]}
                                                            />

                                                        </div>
                                                        <SpanField
                                                            classname="text-danger"
                                                            title={
                                                                socio_demographic_error.education_level
                                                            }
                                                        />
                                                    </div>

                                                </div> */}
                                                {/* <div className="col-md-12">
                                                  
                                                    <div className="frllftfull">
                                                        <div className="form-group  frllft">
                                                            <Label title="Occupation" className="label" isMandatory={true} />
                                                        </div>
                                                        <div className=" frlrit">
                                                            <div className="form-group ">
                                                                <CheckboxOrRadioGroup
                                                                    setName={"occupation"}
                                                                    type={"radio"}
                                                                    controlFunc={this.handleOccupation}
                                                                    options={occupation}
                                                                    selectedOptions={[caseHistory.socio_demographic_formData?.occupation]}
                                                                />

                                                            </div>
                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.occupation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group">
                                                            <div className="form-group  frllft">
                                                                {/* <Label title="Living Situation" className="label" isMandatory={true} /> */}
                                                            </div>
                                                            <TextArea
                                                                className="textareacontainer"
                                                                rows={4}
                                                                resize={true}
                                                                content={this.state.Assessment.overview_of_the_session_value || ""}
                                                                name="overview_of_the_session_value"
                                                                controlFunc={this.handlePurposeofthesessionInputChange}
                                                                placeholder="Describe here"
                                                                maxLength={200}
                                                            />


                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.living_situation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-sm-3">
                                                    <label></label>
                                                    <div className="row">

                                                        {/* <button
                                                            type="button"
                                                            onClick={this.cancelAddEdit.bind(
                                                                this,
                                                                "medicalLicence"
                                                            )}
                                                            className="plusbtn-lft plusbtn-position"
                                                        >
                                                            <i
                                                                className="fa fa fa-ban"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button> */}


                                                    </div>
                                                </div>
                                            </Fragment>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <h5 className=" mt-0 mb-15">
                                            <b>3.Patient's Current status/Condition</b>
                                            {/* <button
                                                style={{
                                                    display: this.state.isDisable
                                                        ? "none"
                                                        : "",
                                                }}
                                                type="button"
                                                className="btn btn-blue btn-sm btn-space"
                                                onClick={() => {
                                                    this.setState({
                                                        medEdit: true,
                                                    });
                                                }}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </button> */}
                                        </h5>

                                        <div
                                            className="row nomargin"
                                            style={{
                                                display: this.state.medEdit
                                                    ? "flex"
                                                    : "flex",
                                            }}
                                        >
                                            <Fragment>

                                                <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group frllft">
                                                            {/* <Label title="Education Level" className="label" isMandatory={true} /> */}
                                                        </div>

                                                        <div className="form-group ">
                                                            <CheckboxOrRadioGroup
                                                                setName={"patient_current_status"}
                                                                type={"radio"}
                                                                controlFunc={this.handlePatientcurrentStatus}
                                                                options={patient_current_status}
                                                                selectedOptions={[Assessment.patient_current_status]}
                                                            />

                                                        </div>
                                                        <SpanField
                                                            classname="text-danger"
                                                            title={
                                                                socio_demographic_error.education_level
                                                            }
                                                        />
                                                    </div>

                                                </div>
                                                {/* <div className="col-md-12">
                                                  
                                                    <div className="frllftfull">
                                                        <div className="form-group  frllft">
                                                            <Label title="Occupation" className="label" isMandatory={true} />
                                                        </div>
                                                        <div className=" frlrit">
                                                            <div className="form-group ">
                                                                <CheckboxOrRadioGroup
                                                                    setName={"occupation"}
                                                                    type={"radio"}
                                                                    controlFunc={this.handleOccupation}
                                                                    options={occupation}
                                                                    selectedOptions={[caseHistory.socio_demographic_formData?.occupation]}
                                                                />

                                                            </div>
                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.occupation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group">
                                                            <div className="form-group  frllft">
                                                                {/* <Label title="Living Situation" className="label" isMandatory={true} /> */}
                                                            </div>
                                                            <TextArea
                                                                className="textareacontainer"
                                                                rows={4}
                                                                resize={true}
                                                                content={this.state.Assessment.patient_current_status_value || ""}
                                                                name="patient_current_status_value"
                                                                controlFunc={this.handlePurposeofthesessionInputChange}
                                                                placeholder="Describe here"
                                                                maxLength={200}
                                                            />


                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.living_situation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-sm-3">
                                                    <label></label>
                                                    <div className="row">

                                                        {/* <button
                                                            type="button"
                                                            onClick={this.cancelAddEdit.bind(
                                                                this,
                                                                "medicalLicence"
                                                            )}
                                                            className="plusbtn-lft plusbtn-position"
                                                        >
                                                            <i
                                                                className="fa fa fa-ban"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button> */}


                                                    </div>
                                                </div>
                                            </Fragment>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <h5 className=" mt-0 mb-15">
                                            <b>4.Progress Towards Goal </b>
                                            {/* <button
                                                style={{
                                                    display: this.state.isDisable
                                                        ? "none"
                                                        : "",
                                                }}
                                                type="button"
                                                className="btn btn-blue btn-sm btn-space"
                                                onClick={() => {
                                                    this.setState({
                                                        medEdit: true,
                                                    });
                                                }}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </button> */}
                                        </h5>

                                        <div
                                            className="row nomargin"
                                            style={{
                                                display: this.state.medEdit
                                                    ? "flex"
                                                    : "flex",
                                            }}
                                        >
                                            <Fragment>

                                                <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group frllft">
                                                            {/* <Label title="Education Level" className="label" isMandatory={true} /> */}
                                                        </div>

                                                        <div className="form-group ">
                                                            <CheckboxOrRadioGroup
                                                                setName={"progress_towards_goal"}
                                                                type={"radio"}
                                                                controlFunc={this.handleProgresstowardsGoal}
                                                                options={progress_towards_goal}
                                                                selectedOptions={[Assessment.progress_towards_goal]}
                                                            />

                                                        </div>
                                                        <SpanField
                                                            classname="text-danger"
                                                            title={
                                                                socio_demographic_error.education_level
                                                            }
                                                        />
                                                    </div>

                                                </div>
                                                {/* <div className="col-md-12">
                                                  
                                                    <div className="frllftfull">
                                                        <div className="form-group  frllft">
                                                            <Label title="Occupation" className="label" isMandatory={true} />
                                                        </div>
                                                        <div className=" frlrit">
                                                            <div className="form-group ">
                                                                <CheckboxOrRadioGroup
                                                                    setName={"occupation"}
                                                                    type={"radio"}
                                                                    controlFunc={this.handleOccupation}
                                                                    options={occupation}
                                                                    selectedOptions={[caseHistory.socio_demographic_formData?.occupation]}
                                                                />

                                                            </div>
                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.occupation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group">
                                                            <div className="form-group  frllft">
                                                                {/* <Label title="Living Situation" className="label" isMandatory={true} /> */}
                                                            </div>
                                                            <TextArea
                                                                className="textareacontainer"
                                                                rows={4}
                                                                resize={true}
                                                                content={this.state.Assessment.progress_towards_goal_value || ""}
                                                                name="progress_towards_goal_value"
                                                                controlFunc={this.handlePurposeofthesessionInputChange}
                                                                placeholder="Describe here"
                                                                maxLength={200}
                                                            />


                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.living_situation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-sm-3">
                                                    <label></label>
                                                    <div className="row">

                                                        {/* <button
                                                            type="button"
                                                            onClick={this.cancelAddEdit.bind(
                                                                this,
                                                                "medicalLicence"
                                                            )}
                                                            className="plusbtn-lft plusbtn-position"
                                                        >
                                                            <i
                                                                className="fa fa fa-ban"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button> */}


                                                    </div>
                                                </div>
                                            </Fragment>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <h5 className=" mt-0 mb-15">
                                            <b>5.Challenges/Barriers</b>
                                            {/* <button
                                                style={{
                                                    display: this.state.isDisable
                                                        ? "none"
                                                        : "",
                                                }}
                                                type="button"
                                                className="btn btn-blue btn-sm btn-space"
                                                onClick={() => {
                                                    this.setState({
                                                        medEdit: true,
                                                    });
                                                }}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </button> */}
                                        </h5>

                                        <div
                                            className="row nomargin"
                                            style={{
                                                display: this.state.medEdit
                                                    ? "flex"
                                                    : "flex",
                                            }}
                                        >
                                            <Fragment>

                                                <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group frllft">
                                                            {/* <Label title="Education Level" className="label" isMandatory={true} /> */}
                                                        </div>

                                                        <div className="form-group ">
                                                            <CheckboxOrRadioGroup
                                                                setName={"challenges"}
                                                                type={"radio"}
                                                                controlFunc={this.handleChallenges}
                                                                options={Challenges}
                                                                selectedOptions={[Assessment.challenges]}
                                                            />

                                                        </div>
                                                        <SpanField
                                                            classname="text-danger"
                                                            title={
                                                                socio_demographic_error.education_level
                                                            }
                                                        />
                                                    </div>

                                                </div>
                                                {/* <div className="col-md-12">
                                                  
                                                    <div className="frllftfull">
                                                        <div className="form-group  frllft">
                                                            <Label title="Occupation" className="label" isMandatory={true} />
                                                        </div>
                                                        <div className=" frlrit">
                                                            <div className="form-group ">
                                                                <CheckboxOrRadioGroup
                                                                    setName={"occupation"}
                                                                    type={"radio"}
                                                                    controlFunc={this.handleOccupation}
                                                                    options={occupation}
                                                                    selectedOptions={[caseHistory.socio_demographic_formData?.occupation]}
                                                                />

                                                            </div>
                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.occupation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group">
                                                            <div className="form-group  frllft">
                                                                {/* <Label title="Living Situation" className="label" isMandatory={true} /> */}
                                                            </div>
                                                            <TextArea
                                                                className="textareacontainer"
                                                                rows={4}
                                                                resize={true}
                                                                content={this.state.Assessment.challenges_value || ""}
                                                                name="challenges_value"
                                                                controlFunc={this.handlePurposeofthesessionInputChange}
                                                                placeholder="Describe here"
                                                                maxLength={200}
                                                            />


                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.living_situation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-sm-3">
                                                    <label></label>
                                                    <div className="row">

                                                        {/* <button
                                                            type="button"
                                                            onClick={this.cancelAddEdit.bind(
                                                                this,
                                                                "medicalLicence"
                                                            )}
                                                            className="plusbtn-lft plusbtn-position"
                                                        >
                                                            <i
                                                                className="fa fa fa-ban"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button> */}


                                                    </div>
                                                </div>
                                            </Fragment>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <h5 className=" mt-0 mb-15">
                                            <b>6.   Interventions/Techniques Used</b>
                                            {/* <button
                                                style={{
                                                    display: this.state.isDisable
                                                        ? "none"
                                                        : "",
                                                }}
                                                type="button"
                                                className="btn btn-blue btn-sm btn-space"
                                                onClick={() => {
                                                    this.setState({
                                                        medEdit: true,
                                                    });
                                                }}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </button> */}
                                        </h5>

                                        <div
                                            className="row nomargin"
                                            style={{
                                                display: this.state.medEdit
                                                    ? "flex"
                                                    : "flex",
                                            }}
                                        >
                                            <Fragment>

                                                {/* <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group frllft">
                                                            <Label title="Education Level" className="label" isMandatory={true} />
                                                        </div>

                                                        <div className="form-group ">
                                                            <CheckboxOrRadioGroup
                                                                setName={"purpose_of_the_session"}
                                                                type={"radio"}
                                                                controlFunc={this.handlePurposeofthesession}
                                                                options={purpose_of_the_session}
                                                                selectedOptions={[Assessment.purpose_of_the_session]}
                                                            />

                                                        </div>
                                                        <SpanField
                                                            classname="text-danger"
                                                            title={
                                                                socio_demographic_error.education_level
                                                            }
                                                        />
                                                    </div>

                                                </div> */}
                                                {/* <div className="col-md-12">
                                                  
                                                    <div className="frllftfull">
                                                        <div className="form-group  frllft">
                                                            <Label title="Occupation" className="label" isMandatory={true} />
                                                        </div>
                                                        <div className=" frlrit">
                                                            <div className="form-group ">
                                                                <CheckboxOrRadioGroup
                                                                    setName={"occupation"}
                                                                    type={"radio"}
                                                                    controlFunc={this.handleOccupation}
                                                                    options={occupation}
                                                                    selectedOptions={[caseHistory.socio_demographic_formData?.occupation]}
                                                                />

                                                            </div>
                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.occupation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group">
                                                            <div className="form-group  frllft">
                                                                {/* <Label title="Living Situation" className="label" isMandatory={true} /> */}
                                                            </div>
                                                            <TextArea
                                                                className="textareacontainer"
                                                                rows={4}
                                                                resize={true}
                                                                content={this.state.Assessment.interventions_value || ""}
                                                                name="interventions_value"
                                                                controlFunc={this.handlePurposeofthesessionInputChange}
                                                                placeholder="Describe here"
                                                                maxLength={200}
                                                            />


                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.living_situation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-sm-3">
                                                    <label></label>
                                                    <div className="row">

                                                        {/* <button
                                                            type="button"
                                                            onClick={this.cancelAddEdit.bind(
                                                                this,
                                                                "medicalLicence"
                                                            )}
                                                            className="plusbtn-lft plusbtn-position"
                                                        >
                                                            <i
                                                                className="fa fa fa-ban"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button> */}


                                                    </div>
                                                </div>
                                            </Fragment>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <h5 className=" mt-0 mb-15">
                                            <b>7. Action Plan & Recommendations</b>
                                            {/* <button
                                                style={{
                                                    display: this.state.isDisable
                                                        ? "none"
                                                        : "",
                                                }}
                                                type="button"
                                                className="btn btn-blue btn-sm btn-space"
                                                onClick={() => {
                                                    this.setState({
                                                        medEdit: true,
                                                    });
                                                }}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </button> */}
                                        </h5>

                                        <div
                                            className="row nomargin"
                                            style={{
                                                display: this.state.medEdit
                                                    ? "flex"
                                                    : "flex",
                                            }}
                                        >
                                            <Fragment>

                                                {/* <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group frllft">
                                                            <Label title="Education Level" className="label" isMandatory={true} />
                                                        </div>

                                                        <div className="form-group ">
                                                            <CheckboxOrRadioGroup
                                                                setName={"purpose_of_the_session"}
                                                                type={"radio"}
                                                                controlFunc={this.handlePurposeofthesession}
                                                                options={purpose_of_the_session}
                                                                selectedOptions={[Assessment.purpose_of_the_session]}
                                                            />

                                                        </div>
                                                        <SpanField
                                                            classname="text-danger"
                                                            title={
                                                                socio_demographic_error.education_level
                                                            }
                                                        />
                                                    </div>

                                                </div> */}
                                                {/* <div className="col-md-12">
                                                  
                                                    <div className="frllftfull">
                                                        <div className="form-group  frllft">
                                                            <Label title="Occupation" className="label" isMandatory={true} />
                                                        </div>
                                                        <div className=" frlrit">
                                                            <div className="form-group ">
                                                                <CheckboxOrRadioGroup
                                                                    setName={"occupation"}
                                                                    type={"radio"}
                                                                    controlFunc={this.handleOccupation}
                                                                    options={occupation}
                                                                    selectedOptions={[caseHistory.socio_demographic_formData?.occupation]}
                                                                />

                                                            </div>
                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.occupation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group">
                                                            <div className="form-group  frllft">
                                                                {/* <Label title="Living Situation" className="label" isMandatory={true} /> */}
                                                            </div>
                                                            <TextArea
                                                                className="textareacontainer"
                                                                rows={4}
                                                                resize={true}
                                                                content={this.state.Assessment.actionplanrecommendation_value || ""}
                                                                name="actionplanrecommendation_value"
                                                                controlFunc={this.handlePurposeofthesessionInputChange}
                                                                placeholder="Describe here"
                                                                maxLength={200}
                                                            />


                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.living_situation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-sm-3">
                                                    <label></label>
                                                    <div className="row">

                                                        {/* <button
                                                            type="button"
                                                            onClick={this.cancelAddEdit.bind(
                                                                this,
                                                                "medicalLicence"
                                                            )}
                                                            className="plusbtn-lft plusbtn-position"
                                                        >
                                                            <i
                                                                className="fa fa fa-ban"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button> */}


                                                    </div>
                                                </div>
                                            </Fragment>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <h5 className=" mt-0 mb-15">
                                            <b>8. Conclusion</b>
                                            {/* <button
                                                style={{
                                                    display: this.state.isDisable
                                                        ? "none"
                                                        : "",
                                                }}
                                                type="button"
                                                className="btn btn-blue btn-sm btn-space"
                                                onClick={() => {
                                                    this.setState({
                                                        medEdit: true,
                                                    });
                                                }}
                                            >
                                                <i className="fa fa-plus"></i>
                                            </button> */}
                                        </h5>

                                        <div
                                            className="row nomargin"
                                            style={{
                                                display: this.state.medEdit
                                                    ? "flex"
                                                    : "flex",
                                            }}
                                        >
                                            <Fragment>

                                                {/* <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group frllft">
                                                            <Label title="Education Level" className="label" isMandatory={true} />
                                                        </div>

                                                        <div className="form-group ">
                                                            <CheckboxOrRadioGroup
                                                                setName={"purpose_of_the_session"}
                                                                type={"radio"}
                                                                controlFunc={this.handlePurposeofthesession}
                                                                options={purpose_of_the_session}
                                                                selectedOptions={[Assessment.purpose_of_the_session]}
                                                            />

                                                        </div>
                                                        <SpanField
                                                            classname="text-danger"
                                                            title={
                                                                socio_demographic_error.education_level
                                                            }
                                                        />
                                                    </div>

                                                </div> */}
                                                {/* <div className="col-md-12">
                                                  
                                                    <div className="frllftfull">
                                                        <div className="form-group  frllft">
                                                            <Label title="Occupation" className="label" isMandatory={true} />
                                                        </div>
                                                        <div className=" frlrit">
                                                            <div className="form-group ">
                                                                <CheckboxOrRadioGroup
                                                                    setName={"occupation"}
                                                                    type={"radio"}
                                                                    controlFunc={this.handleOccupation}
                                                                    options={occupation}
                                                                    selectedOptions={[caseHistory.socio_demographic_formData?.occupation]}
                                                                />

                                                            </div>
                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.occupation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div> */}
                                                <div className="col-md-12">
                                                    <div className="frllftfull">
                                                        <div className="form-group">
                                                            <div className="form-group  frllft">
                                                                {/* <Label title="Living Situation" className="label" isMandatory={true} /> */}
                                                            </div>
                                                            <TextArea
                                                                className="textareacontainer"
                                                                rows={4}
                                                                resize={true}
                                                                content={this.state.Assessment.conclusion || ""}
                                                                name="conclusion"
                                                                controlFunc={this.handlePurposeofthesessionInputChange}
                                                                placeholder="Describe here"
                                                                maxLength={200}
                                                            />


                                                            <SpanField
                                                                classname="text-danger"
                                                                title={
                                                                    socio_demographic_error.living_situation
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="col-sm-3">
                                                    <label></label>
                                                    <div className="row">

                                                        {/* <button
                                                            type="button"
                                                            onClick={this.cancelAddEdit.bind(
                                                                this,
                                                                "medicalLicence"
                                                            )}
                                                            className="plusbtn-lft plusbtn-position"
                                                        >
                                                            <i
                                                                className="fa fa fa-ban"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </button> */}


                                                    </div>
                                                </div>
                                            </Fragment>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>

                </div>
                <div className="">
                <button className=" signupbtn  pad-6  margin-10 " onClick={this.props.onPreviousClick}  >Previous</button>
                                   
                    <div className="text-center mt-2 mr-2 float-right"><button onClick={() =>
                        this.submitPrescription()
                    } className=" signupbtn  pad-6 margin-10" >Next</button>
                    </div>
                </div>

            </>

        );
    }
    handleEducationLevel = (e) => {
        let data = this.state.caseHistory.socio_demographic_formData;
        data.education_level = e.target.value;
        this.setState({ socio_demographic_formData: data });
    };
    handlePurposeofthesession = (e) => {
        let data = this.state.Assessment;
        data.purpose_of_the_session = e.target.value;
        this.setState({ Assessment: data });
    };
    handleChallenges = (e) => {
        let data = this.state.Assessment;
        data.challenges = e.target.value;
        this.setState({ Assessment: data });
    };
    handleProgresstowardsGoal = (e) => {
        let data = this.state.Assessment;
        data.progress_towards_goal = e.target.value;
        this.setState({ Assessment: data });
    };
    handlePatientcurrentStatus = (e) => {
        let data = this.state.Assessment;
        data.patient_current_status = e.target.value;
        this.setState({ Assessment: data });
    };
    handleSpeech = (e) => {
        let data = this.state.caseHistory.mental_status_examination;
        data.speech = e.target.value;
        this.setState({ mental_status_examination: data });
    };
    handleThoughtProcess = (e) => {
        let data = this.state.caseHistory.mental_status_examination;
        data.thought_process = e.target.value;
        this.setState({ mental_status_examination: data });
    };
    handleInsight = (e) => {
        let data = this.state.caseHistory.mental_status_examination;
        data.insight = e.target.value;
        this.setState({ mental_status_examination: data });
    };
    handleOccupation = (e) => {
        let data = this.state.caseHistory.socio_demographic_formData;
        data.occupation = e.target.value;
        this.setState({ socio_demographic_formData: data });
    };
    handleOngoingStressors = (e) => {
        let data = this.state.caseHistory.perpetuating_factors;
        data.ongoing_stressors = e.target.value;
        this.setState({ perpetuating_factors: data });
    };
    handleHandleSittingUp = (e) => {
        let data = this.state.caseHistory.developmental_history.early_milestone;
        data.sitting_up = e.target.value;
        this.setState({ early_milestone: data });
    };
    handleHandleSpeechDevelopment = (e) => {
        let data = this.state.caseHistory.developmental_history.early_milestone;
        data.speech_development = e.target.value;
        this.setState({ early_milestone: data });
    };
    handleTriggers = (e) => {
        const { value, checked } = e.target;
        const { triggers } = this.state.caseHistory.presenting_complaints_formData;

        if (checked) {
            // Add the trigger if checked
            this.setState(prevState => ({
                caseHistory: {
                    ...prevState.caseHistory,
                    presenting_complaints_formData: {
                        ...prevState.caseHistory.presenting_complaints_formData,
                        triggers: [...triggers, value]
                    }
                }
            }));

            if (value == "others") {
                console.log("others");
            }
        } else {
            // Remove the trigger if unchecked
            this.setState(prevState => ({
                caseHistory: {
                    ...prevState.caseHistory,
                    presenting_complaints_formData: {
                        ...prevState.caseHistory.presenting_complaints_formData,
                        triggers: checked
                            ? [...triggers, value]
                            : triggers.filter(trigger => trigger !== value)
                    }
                }
            }));

        }
    };
    handleStressors = (e) => {
        const { value, checked } = e.target;
        const { stressors } = this.state.caseHistory.presenting_factors_formData;

        if (checked) {
            // Add the stressor if checked
            this.setState(prevState => ({
                caseHistory: {
                    ...prevState.caseHistory,
                    presenting_factors_formData: {
                        ...prevState.presenting_factors_formData,
                        stressors: [...stressors, value]
                    }
                }
            }));

            if (value == "others") {
                console.log("others");
            }
        } else {
            // Remove the stressor if unchecked
            this.setState(prevState => ({
                caseHistory: {
                    ...prevState.caseHistory,
                    presenting_factors_formData: {
                        ...prevState.presenting_factors_formData,
                        stressors: stressors.filter(stressor => stressor !== value)
                    }
                }
            }));
        }
    };
    handleRecentLifeEvents = (e) => {
        const { value, checked } = e.target;
        const { recent_life_events } = this.state.caseHistory.preciptating_history;

        if (checked) {
            // Add the trigger if checked
            this.setState(prevState => ({
                caseHistory: {
                    ...prevState.caseHistory,
                    preciptating_history: {
                        ...prevState.caseHistory.preciptating_history,
                        recent_life_events: [...recent_life_events, value]
                    }
                }
            }));

            if (value == "others") {
                console.log("others");
            }
        } else {
            // Remove the trigger if unchecked
            this.setState(prevState => ({
                caseHistory: {
                    ...prevState.caseHistory,
                    preciptating_history: {
                        ...prevState.caseHistory.preciptating_history,
                        recent_life_events: checked
                            ? [...recent_life_events, value]
                            : recent_life_events.filter(recent => recent !== value)
                    }
                }
            }));

        }
    };

    handleResponsetoTreatment = (e) => {
        let data = this.state.caseHistory.past_treatment_history;
        data.response_to_treatment = e.target.value;
        this.setState({ past_treatment_history: data });
    };
    handleFamilyHistoryofMentalheathIssues = (e) => {
        let data = this.state.caseHistory.family_history;
        data.family_history_of_mental_health_issues = e.target.value;
        this.setState({ family_history: data });
    };
    handleTypeofConditions = (e) => {
        const { value, checked } = e.target;
        const { type_of_conditions } = this.state.caseHistory.family_history;

        if (checked) {
            // Add the stressor if checked
            this.setState(prevState => ({
                caseHistory: {
                    ...prevState.caseHistory,
                    family_history: {
                        ...prevState.family_history,
                        type_of_conditions: [...type_of_conditions, value]
                    }
                }
            }));

            if (value == "others") {
                console.log("others");
            }
        } else {
            // Remove the stressor if unchecked
            this.setState(prevState => ({
                caseHistory: {
                    ...prevState.caseHistory,
                    family_history: {
                        ...prevState.family_history,
                        type_of_conditions: type_of_conditions.filter(type => type !== value)
                    }
                }
            }));
        }
    };


    handleSeverity = (e) => {
        let data = this.state.caseHistory.presenting_complaints_formData;
        data.severity = e.target.value;
        this.setState({ presenting_complaints_formData: data });
    };
    handleInputChange = (e) => {
        let data = this.state.caseHistory.socio_demographic_formData;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "living_situation"


        ) {
            this.validateMaxLength(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ socio_demographic_formData: data });
    };
    handlePresentingcomplaintsmainissueInputChange = (e) => {
        let data = this.state.caseHistory.presenting_complaints_formData;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "main_issue"


        ) {
            this.validateMaxLengthpresentingcomplaints(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ presenting_complaints_formData: data });
    };

    handlePresentingcomplaintsInputChange = (e) => {
        const { name, value, max } = e.target;

        // Create a shallow copy of the current form data

        if (name === "duration") {
            // Perform validation if necessary
            this.validateMaxLengthpresentingcomplaints(name, value, max);
        } else {

            this.setState(prevState => ({
                caseHistory: {
                    ...prevState.caseHistory,
                    presenting_complaints_formData: {
                        ...prevState.caseHistory.presenting_complaints_formData,
                        [name]: value
                    }
                }
            }));

        }



    };
    handlePerpetuatingFactorsInputChange = (e) => {
        let data = this.state.caseHistory.perpetuating_factors;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "behavioural_pattern_maintaining_symptoms" || name === "lack_of_support_system"


        ) {
            this.validateMaxLengthPerpetuatingFactors(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ perpetuating_factors: data });
    };
    validateMaxLengthPerpetuatingFactors(name, value, max) {
        let data = this.state.caseHistory.perpetuating_factors;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {

            data[name] = value;
        }
        this.setState({ perpetuating_factors: data, errors: errors });
    }
    handlePreciptatingHistoryInputChange = (e) => {
        let data = this.state.caseHistory.preciptating_history;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "changes_in_routine"


        ) {
            this.validateMaxLengthPresciptatingHistory(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ preciptating_history: data });
    };
    validateMaxLengthPresciptatingHistory(name, value, max) {
        let data = this.state.caseHistory.preciptating_history;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {

            data[name] = value;
        }
        this.setState({ preciptating_history: data, errors: errors });
    }
    handlePresentingfactorsInputChange = (e) => {
        let data = this.state.caseHistory.presenting_factors_formData;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "immediate_symptoms"


        ) {
            this.validateMaxLengthpresentingfactors(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ presenting_factors_formData: data });
    };
    handleCaseFormulationInputChange = (e) => {
        let data = this.state.caseHistory;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "case_formulation"


        ) {
            this.validateMaxLengthcaseformulation(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ caseHistory: data });
    };
    validateMaxLengthcaseformulation(name, value, max) {
        let data = this.state.caseHistory;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {

            data[name] = value;
        }
        this.setState({ caseHistory: data, errors: errors });
    }
    handleDevelopmentalHistoryInput = (e) => {
        let data = this.state.caseHistory.developmental_history;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "birth_history"


        ) {
            this.validateMaxLengthdevelopmentalhistory(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ developmental_history: data });
    };
    validateMaxLengthdevelopmentalhistory(name, value, max) {
        let data = this.state.caseHistory.developmental_history;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {

            data[name] = value;
        }
        this.setState({ developmental_history: data, errors: errors });
    }
    handlePremorbidHistoryInput = (e) => {
        let data = this.state.caseHistory.premorbid_history;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "social_relationship" || name === "functioning_in_daily_life"


        ) {
            this.validateMaxLengthPremorbidHistory(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ premorbid_history: data });
    };
    validateMaxLengthPremorbidHistory(name, value, max) {
        let data = this.state.caseHistory.premorbid_history;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {
            data[name] = value;
        }
        this.setState({ premorbid_history: data, errors: errors });
    }
    handleDevelopmentalHistorySocialDevelopmentInput = (e) => {
        let data = this.state.caseHistory.developmental_history.social_development;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "early_friendships" || name === "group_activities_participation"


        ) {
            this.validateMaxLengthdevelopmentalhistorySocialDevelopment(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ social_development: data });
    };
    validateMaxLengthdevelopmentalhistorySocialDevelopment(name, value, max) {
        let data = this.state.caseHistory.developmental_history.social_development;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {
            data[name] = value;
        }
        this.setState({ social_development: data, errors: errors });
    }

    handleDevelopmentalHistoryAcademicPerformanceInput = (e) => {
        let data = this.state.caseHistory.developmental_history.academic_performance;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "early_schooling_experience" || name === "grades_and_subjects"


        ) {
            this.validateMaxLengthdevelopmentalhistoryAcademicPerformance(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ academic_performance: data });
    };
    validateMaxLengthdevelopmentalhistoryAcademicPerformance(name, value, max) {
        let data = this.state.caseHistory.developmental_history.academic_performance;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {
            data[name] = value;
        }
        this.setState({ academic_performance: data, errors: errors });
    }
    handleDevelopmentalHistoryFamilyDynamicsInput = (e) => {
        let data = this.state.caseHistory.developmental_history.family_dynamics;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "relationship_with_parents_siblings" || name === "significant_family_events"


        ) {
            this.validateMaxLengthdevelopmentalhistoryFamilyDynamics(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ family_dynamics: data });
    };
    validateMaxLengthdevelopmentalhistoryFamilyDynamics(name, value, max) {
        let data = this.state.caseHistory.developmental_history.family_dynamics;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {
            data[name] = value;
        }
        this.setState({ family_dynamics: data, errors: errors });
    }

    handleDevelopmentalHistoryBehaviouralIssuesInput = (e) => {
        let data = this.state.caseHistory.developmental_history.behavioral_issues;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "reported_problems_in_childhood" || name === "invervention_or_assessments"


        ) {
            this.validateMaxLengthdevelopmentalhistoryBehaviouralIssues(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ behavioral_issues: data });
    };
    validateMaxLengthdevelopmentalhistoryBehaviouralIssues(name, value, max) {
        let data = this.state.caseHistory.developmental_history.behavioral_issues;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {
            data[name] = value;
        }
        this.setState({ behavioral_issues: data, errors: errors });
    }
    handleGenogram = (e) => {
        let data = this.state.caseHistory.family_history;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "genogram"


        ) {
            this.validateMaxLengthGenogram(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ family_history: data });
    };
    validateMaxLengthGenogram(name, value, max) {
        let data = this.state.caseHistory.family_history;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {

            data[name] = value;
        }
        this.setState({ family_history: data, errors: errors });
    }
    handlePastTreatmentHistoryInputChange = (e) => {
        let data = this.state.caseHistory.past_treatment_history;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "previous_diagnosis" || name === "treatment"


        ) {
            this.validateMaxLengthPastTreatmentHistory(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ presenting_factors_formData: data });
    };
    validateMaxLengthPastTreatmentHistory(name, value, max) {
        let data = this.state.caseHistory.past_treatment_history;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {

            data[name] = value;
        }
        this.setState({ past_treatment_history: data, errors: errors });
    }
    validateMaxLengthpresentingfactors(name, value, max) {
        let data = this.state.caseHistory.presenting_factors_formData;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {

            data[name] = value;
        }
        this.setState({ presenting_factors_formData: data, errors: errors });
    }
    validateMaxLengthpresentingcomplaints(name, value, max) {
        let data = this.state.caseHistory.presenting_complaints_formData;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            //  errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {

            data[name] = value;
        }
        this.setState({ presenting_complaints_formData: data, errors: errors });
    }
    handlePersonalityTraits = (e) => {
        let data = this.state.caseHistory.premorbid_history;
        data.personality_traits = e.target.value;
        this.setState({ premorbid_history: data });
    };
    validateMaxLength(name, value, max) {
        let data = this.state.caseHistory.socio_demographic_formData;
        let errors = this.state.errors;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            //  errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {

            data[name] = value;
        }
        this.setState({ socio_demographic_formData: data, errors: errors });
    }
    // addSocioDemographicDetail() {
    //   let formData = this.state.socio_demographic_formData;
    //   formData.type = "addSocioDemographic";
    //   let { socio_demographic_error } = this.state;
    //   socio_demographic_error = Validation(formData, socio_demographic_error);
    //   this.setState({ socio_demographic_error: socio_demographic_error });

    //   if (socio_demographic_error.formIsValid) {
    //     let records = this.state.socio_demographic_details;
    //     let record = "";
    //     if ("" === formData.id) {
    //       let record = Object.assign({}, socio_demographic_record);
    //       record.id = getMaxIdOfRecords(records);

    //       if (records.length > 0) {
    //         let maxId = Math.max.apply(
    //           Math,
    //           records.map(function (o) {
    //             return o.id;
    //           })
    //         );
    //         record.s_no = maxId + 1;
    //       } else {
    //         record.s_no = records.length + 1;
    //       }
    //       record.education_level = formData.education_level;
    //       record.occupation = formData.occupation;
    //       record.living_situation = formData.living_situation;
    //       record.s_no = records.length + 1;
    //       console.log(record);
    //       records.push(record);
    //     } else {
    //       const updateRecordIndex = records
    //         .map((item) => item.id)
    //         .indexOf(formData.id);
    //       let record = records[updateRecordIndex];
    //       record.education_level = formData.education_level;
    //       record.occupation = formData.occupation;
    //       record.living_situation = formData.living_situation;
    //     }

    //     let initalData = Object.assign({}, socio_demographic_record);
    //     this.setState({
    //       socio_demographic_formData: initalData,
    //       medAction: "",
    //       medEdit: false,
    //     });
    //   }
    // }
    cancelAddEdit(tableName, e) {
        let initalData = "";
        if ("education" === tableName) {
            initalData = Object.assign({}, eq_record);
            this.setState({
                educational_qualification_formData: initalData,
                edAction: "",
                edEdit: false,
            });
        } else if ("certificate" === tableName) {
            initalData = Object.assign({}, cert_record);
            this.setState({
                certifications_formData: initalData,
                certAction: "",
                certEdit: false,
            });
        } else if ("experience" === tableName) {
            initalData = Object.assign({}, experience_record);
            this.setState({
                experiences_formData: initalData,
                exAction: "",
                exEdit: false,
            });
        } else if ("medicalLicence" === tableName) {
            initalData = Object.assign({}, socio_demographic_record);
            this.setState({
                socio_demographic_formData: initalData,
                medAction: "",
                medEdit: false,
            });
        }
    }
    // editMedicalRecord(record) {
    //   let dataObj = this.state.caseHistory.socio_demographic_formData;
    //   dataObj.id = record.id;
    //   dataObj.education_level = record.education_level;
    //   dataObj.occupation = record.occupation;
    //   dataObj.living_situation = record.living_situation;
    //   console.log(dataObj);
    //   this.setState({ socio_demographic_formData: dataObj });
    // }

    handlePurposeofthesessionInputChange = (e) => {
        let data = this.state.Assessment;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;

        if (

            name === "purpose_of_the_session_value"||name==="overview_of_the_session_value"
            ||name==="patient_current_status_value"||name==="progress_towards_goal_value"||
            name==="challenges_value"||name==="interventions_value"||name==="actionplanrecommendation_value"||
            name==="conclusion"


        ) {
            this.validateMaxLengthpurposeofthesession(name, value, max);
        } else {
            data[name] = value;
        }

        this.setState({ Assessment: data });


    };
    validateMaxLengthpurposeofthesession(name, value, max) {
        let data = this.state.Assessment;
        // let errors = this.state.socio_demographic_error;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            //  errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {
            // errors[name] = "";
            data[name] = value;
        }
        this.setState({ Assessment: data });
    }


    handleSocioDemographicInputChange = (e) => {
        let data = this.state.caseHistory.socio_demographic_formData;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;

        if (

            name === "living_situation"


        ) {
            this.validateMaxLengthforsociodemographic(name, value, max);
        } else {
            data[name] = value;
        }

        this.setState({ socio_demographic_formData: data });


    };

    handleMentalStatusExaminationInputChange = (e) => {
        let data = this.state.caseHistory.mental_status_examination;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "appearence" ||
            name === "behavior" ||
            name === "mood" ||
            name === "thought_content" ||
            name === "perception" ||
            name === "cognition_orientation"


        ) {
            this.validateMaxLengthmentalstatusexamination(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ mental_status_examination: data });
    };
    validateMaxLengthmentalstatusexamination(name, value, max) {
        let data = this.state.caseHistory.mental_status_examination;
        // let errors = this.state.socio_demographic_error;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            //  errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {
            // errors[name] = "";
            data[name] = value;
        }
        this.setState({ mental_status_examination: data });
    }

    handlePrognosticFactorsInputChange = (e) => {
        let data = this.state.caseHistory.prognostic_factors;
        let name = e.target.name;
        let value = e.target.value;
        let max = e.target.max;
        if (
            name === "severity_and_duration_of_symptoms" ||
            name === "response_to_previous_treatments" ||
            name === "support_systems_available" ||
            name === "comorbid_conditions"


        ) {
            this.validateMaxLengthPrognosticfactors(name, value, max);
        } else {
            data[name] = value;
        }
        this.setState({ prognostic_factors: data });
    };
    validateMaxLengthPrognosticfactors(name, value, max) {
        let data = this.state.caseHistory.prognostic_factors;
        // let errors = this.state.socio_demographic_error;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            //  errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {
            // errors[name] = "";
            data[name] = value;
        }
        this.setState({ prognostic_factors: data });
    }
    submitPrescription() {
        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${this.props.access_token}`;
        console.log(this.props.id)
        const checkinData = { id: this.props.id };

        axios
            .post(getCheckinDetails, checkinData, CONFIG)
            .then((res) => {
                let data = res.data.data || res.data.date;
                if (res.data.status !== "1" || !data) {
                    return;
                }


                console.log(res.data.status)
                this.setState({
                    checkindetails: res.data.data,
                    client_id: this.state.checkindetails.client_id,
                    business_id: this.state.checkindetails.business_id,
                    business_user_id: this.state.checkindetails.business_user_id,

                });
                console.log(this.state.checkindetails);
                console.log(this.state.checkindetails.client_id);
                let Assessment = this.state.Assessment;
                Assessment.id = this.props.id;
                Assessment.client_id = this.state.checkindetails.client_id;
                Assessment.business_id = this.state.checkindetails.business_id;
                Assessment.business_user_id = this.state.checkindetails.business_user_id;
                let newdata = Object.assign({}, Assessment);
                newdata.purpose_of_the_session = Assessment.purpose_of_the_session;
                newdata.purpose_of_the_session_value = Assessment.purpose_of_the_session_value;
                newdata.overview_of_the_session_value = Assessment.overview_of_the_session_value;
                newdata.patient_current_status = Assessment.patient_current_status;
                newdata.patient_current_status_value = Assessment.patient_current_status_value;
                newdata.progress_towards_goal = Assessment.progress_towards_goal;
                newdata.progress_towards_goal_value = Assessment.progress_towards_goal_value;
                newdata.challenges= Assessment.challenges;
                newdata.challenges_value = Assessment.challenges_value
                newdata.interventions_value = Assessment.interventions_value;
                newdata.actionplanrecommendation_value = Assessment.actionplanrecommendation_value;
                newdata.conclusion = Assessment.conclusion;
                console.log(newdata);
                // let postData = {};
                // postData.id = this.props.id;
                // postData.socio_demographic_details = this.state.socio_demographic_details;
                // postData.client_id = this.state.checkindetails.client_id;
                // postData.business_id = this.state.checkindetails.business_id;
                // postData.business_user_id = this.state.checkindetails.business_user_id;
                axios.defaults.headers.common[
                    "Authorization"
                ] = `Bearer ${this.props.access_token}`;
                this.setState({ loading: true }, () => {
                    axios
                        .post(consultPsychiatristAssessmentDoctor, newdata, CONFIG)
                        .then((res) => {
                            this.setState({ loading: false });
                            const result = res.data;
                            if (result.status === "1") {
                                this.setState({ PrescriptionsuccessMessage: "Your Prescription details have been updated successfully." });
                            } else {
                                this.setState({
                                    PrescriptionerrorMessage:
                                        result.message || "Failed to submit prescription details",
                                });
                            }
                            this.setState({ activeTab: "Prescription" })

                        })
                        .catch((e) => {
                            this.setState({
                                loading: false,
                                errorMessage: "Failed to submit consultant details",
                                activeTab: "Follow up"
                            });
                        });


                    this.clearMessage();
                });




            }).catch((e) => { });


    }

    validateMaxLengthforsociodemographic(name, value, max) {
        let data = this.state.caseHistory.socio_demographic_formData;
        let errors = this.state.socio_demographic_error;
        if (value.length > max) {
            const value1 = value.slice(0, max);
            errors[name] = "Maximum Length has exceeded.";
            data[name] = value1;
        } else {
            errors[name] = "";
            data[name] = value;
        }
        this.setState({ socio_demographic_formData: data, errors: errors });
    }
}


export default withRouter(connect(
    mapStateToProps,
)(AssessmentPsychiatrist)
);